// src/components/PolicyLayout.jsx
import React from 'react';
import Navbar from './Navbar';
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import WhatsAppButton from '../components/WhatsAppButton';

const PolicyLayout = ({ title, seoLabel, children }) => {
    return (
        <div className="relative z-10 min-h-screen bg-transparent text-white pt-12">
            <Navbar />



            {/* Internal Linking Nav */}
            <div className="flex justify-center gap-4 mb-8 pt-8 text-[14px] uppercase tracking-widest text-zinc-500">
                <a href="/privacy" className="hover:text-[#F3CA52]">Privacy Policy</a>
                <span>|</span>
                <a href="/term" className="hover:text-[#F3CA52]">Terms of Use</a>
                <span>|</span>
                <a href="/refund" className="hover:text-[#F3CA52]">Refund Policy</a>
            </div>

            {/* Glass Card Content Area */}
            <section className="px-4 pb-24">
                <div className="max-w-7xl mx-auto backdrop-blur-xl bg-black/40 border border-white/10 rounded-3xl p-8 md:p-16 shadow-[0_0_80px_rgba(242,177,53,0.15)]">
                    {children}
                </div>
            </section>
            <CTA />
            <Footer />
            <WhatsAppButton />
        </div>
    );
};

export default PolicyLayout;